/**
 * Iovation / IGLOO device fingerprinting — same pattern as checkout-frontend LuwaSecurity.
 */

const LOADER_SCRIPT_SRC = '/assets/js/iovation_loader_only.js';
const LOADER_SCRIPT_ID = 'iovation-loader-script';
const BLACKBOX_INPUT_ID = 'ioBlackBox';

export const initIovation = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  if (document.body && !document.getElementById(BLACKBOX_INPUT_ID)) {
    const hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.id = BLACKBOX_INPUT_ID;
    hidden.name = BLACKBOX_INPUT_ID;
    document.body.appendChild(hidden);
  }

  // Don't overwrite IGLOO after the loader has attached getBlackbox
  if (!window.IGLOO || typeof window.IGLOO.getBlackbox !== 'function') {
    window.io_global_object_name = 'IGLOO';
    window.IGLOO = {
      loader: {
        uri_hook: '/iojs/',
        version: 'general5',
        subkey: '',
      },
    };
  }

  if (document.getElementById(LOADER_SCRIPT_ID)) {
    return;
  }

  const script = document.createElement('script');
  script.id = LOADER_SCRIPT_ID;
  script.async = true;
  script.src = LOADER_SCRIPT_SRC;
  document.head.appendChild(script);
};

export const getBlackbox = () => {
  if (!window.IGLOO || typeof window.IGLOO.getBlackbox !== 'function') {
    console.log('❌ IGLOO not ready — run a collect first');
    return;
  }
  const result = window.IGLOO.getBlackbox();
  // console.log('result.blackbox:', result.blackbox);
  return result.blackbox || '';
};
